module.exports = __webpack_public_path__ + "img/CineCameraSetup.603154fb.png";